import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { change, submit } from 'redux-form'
import { examFindingInfo, examSelectedFinding } from '../../../../../redux/actions/exam/examFindingActions'

function FindingList(props) {
  // Findings Listing by Autocomplete
  const { findings, name, activeTab, wrapperClasses, isHeaderModule, internalAttributesId, externalAttributesId } = props
  const dispatch = useDispatch()

  const handleExternalExternalNilCase = (finding) => {
    let formName = getFormName()
    if (formName !== 'examExternalInternalForm') {
      const isExternal = name.includes('external_attributes')
      const isInternal = name.includes('internal_attributes')
      if (isExternal) {
        dispatch(change('examExternalInternalForm', 'external_attributes.id', externalAttributesId ?? ''))
      }
      else if (isInternal) {
        dispatch(change('examExternalInternalForm', 'internal_attributes.id', internalAttributesId ?? ''))
      }
    }
  }

  const handleSelectFinding = (finding) => {
    let formName = getFormName()
    if (isHeaderModule) {
      formName = 'examHeaderForm'
    }
    else {
      const isAdditionalTest = name?.includes('additional_tests_attributes')
      const isExternalInternalTest = (name.includes('external_attributes') || name.includes('internal_attributes'))
      // if (formName === 'examAdditionalTestForm' && !isAdditionalTest) {
      //   formName = 'examExternalInternalForm'
      // } else if (!formName && isAdditionalTest) {
      //   formName = 'examAdditionalTestForm'
      // }
      if (isAdditionalTest) {
        formName = 'examAdditionalTestForm'
      }
      else if (isExternalInternalTest) {
        formName = 'examExternalInternalForm'
        handleExternalExternalNilCase(finding)
      }
    }
    dispatch(change(formName, name, finding.name))
    dispatch(examSelectedFinding(finding))
    dispatch(examFindingInfo({ dropdownType: finding.impressions_attributes?.length ? 'finding_impression' : 'impression_settings' }))
    if (isHeaderModule) {
      setTimeout(() => dispatch(submit('examHeaderForm')), 800);
    }
  }

  const getFormName = () => {
    switch (activeTab) {
      case 2: return 'examHpiForm'
      case 6: return 'examPreliminaryBinocularForm'
      case 7: return 'examRefractionContactLensForm'
      case 8: return 'examExternalInternalForm'
      case 9: return 'examAdditionalTestForm'
      case 11: return 'examFinalizePrescriptionForm'
      default: return undefined;
    }
  }

  const addFromImpressionSettings = (finding) => {
    handleSelectFinding(finding)
    dispatch(examFindingInfo({ dropdownType: 'impression_settings' }))
  }

  const addFromFindingSettings = (finding) => {
    handleSelectFinding(finding)
    dispatch(examFindingInfo({ dropdownType: 'finding_impression' }))
  }

  return (
    <div className={`${wrapperClasses}`}>
      {findings.length ?
        findings?.map(((finding) => <div className='d-flex justify-content-between'>
          <p key={finding.id} className='mb-2 pointer' onClick={() => handleSelectFinding(finding)}>{finding.name}</p>
          <div>
            {finding.impressions_attributes.length ?
              <p className='text-primary pointer' onClick={() => addFromFindingSettings(finding)}><i className="las la-check-circle font-size-20"></i></p> :
              <p className='text-primary pointer' onClick={() => addFromImpressionSettings(finding)}>+ Add Dx</p>
            }
          </div>
        </div>
        )) :
        <h6 className='text-center py-2 text-muted'>No Record Found</h6>
      }
    </div>
  )
}

const mapStateToProps = (state) => {
  const { other, exam } = state;
  return {
    activeTab: other.activeTab.exam,
    externalAttributesId: exam?.exam?.external_attributes?.id,
    internalAttributesId: exam?.exam?.internal_attributes?.id
  };
};

export default connect(mapStateToProps)(FindingList);